import { render, staticRenderFns } from "./LoginOTP.vue?vue&type=template&id=490ff2e3&scoped=true"
import script from "./LoginOTP.vue?vue&type=script&lang=js"
export * from "./LoginOTP.vue?vue&type=script&lang=js"
import style0 from "./LoginOTP.vue?vue&type=style&index=0&id=490ff2e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ff2e3",
  null
  
)

export default component.exports